// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@awc/App/Widgets/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@awc/App/Widgets/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

export const XngGaTrackSerach: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const query = getQueryStrings(state).query;
    if (state.xGoogleAnalytics.searchEvent && query) {
        const dataLayer = getDataLayer();
        const session = getSession(state);

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.searchEventName,
            search_term: query,
            numResults: props.apiResult.products?.length,
            affiliation: state.xGoogleAnalytics.affiliation,
            user: session.email,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(chain, XngGaTrackSerach);
